import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaCm040 } from '@/endpoints/ApiTaCm040'

// State types
export type MemberNameState = {
  member: {
    lastName: string
    firstName: string
    memNameKana: string
  }
} | null

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/MemberName',
})
export default class MemberName extends VuexModule {
  // State
  private member_: MemberNameState = null

  // Getter
  get member(): MemberNameState {
    return this.member_
  }

  @Mutation
  updateMember(newState: MemberNameState) {
    this.member_ = newState
  }

  @Action
  clear() {
    this.context.commit('updateMember', null)
  }

  @Action
  async refreshMember() {
    logger.trace('in: refreshMember')
    const api = new ApiTaCm040.Api()

    const result = await api.get<MemberNameState>(
      {
        query: {},
      },
      // success
      (data, _) => {
        return {
          member: {
            lastName: data.member.lastName,
            firstName: data.member.firstName,
            memNameKana: data.member.memNameKana,
          },
        }
      },
      // error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateMember', result)
  }
}
